import { MessageChannelsToIds, SupportedMessageFormats } from "../../../Contracts";
const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: (channel, data, id) => {
        return {
            jsonrpc: "2.0",
            params: data,
            method: channel,
            id: id || MessageChannelsToIds[channel]
        };
    }
};
export function RequestFormatter(type, channel, data, id) {
    return JSON.stringify(formats[type](channel, data, id));
}
//# sourceMappingURL=RequestFormatter.js.map